var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_151",
    "data-name": "Group 151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.326,
    height: 18.08,
    viewBox: "0 0 104.326 18.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 104.326,
    height: 18.08,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M2.179,17A3.449,3.449,0,0,1,4.625,13.68l.251-.077,0,.263c0,.031,0,.061,0,.091a8.747,8.747,0,0,0,2.59,6.184l.333.328H5.651A3.476,3.476,0,0,1,2.179,17m11.385,3.472a6.512,6.512,0,1,1,0-13.025A6.441,6.441,0,0,1,18.2,9.378l.194.2,0,0-.259.11a6.79,6.79,0,0,0-1.014.538,1.1,1.1,0,0,0,1.124,1.865,4.514,4.514,0,0,1,1.957-.724,4.666,4.666,0,0,1,.566-.035,4.568,4.568,0,0,1,0,9.137ZM8.47,6.926A8.651,8.651,0,0,0,5.31,11.24l-.04.12-.126.011a5.65,5.65,0,0,0,.506,11.277h15.12a6.748,6.748,0,0,0,.136-13.494l-.1,0-.056-.082A8.672,8.672,0,0,0,8.47,6.926",
    transform: "translate(0 -5.265)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1.078,
    x2: -0.086,
    y2: 1.078,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#2f3385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#403284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#892e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#df297b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#ec297b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#be2b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec297b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M341.065,50.269a4.088,4.088,0,0,0-1.677-1.2,6.985,6.985,0,0,0-2.618-.428,19.061,19.061,0,0,0-3.037.22,19.7,19.7,0,0,0-2.227.465V61.714h2.963V51.385c.194-.031.5-.074.9-.123a10.006,10.006,0,0,1,1.175-.074,3.54,3.54,0,0,1,1.286.208,1.772,1.772,0,0,1,.833.662,3.1,3.1,0,0,1,.439,1.175,9.591,9.591,0,0,1,.137,1.751v6.73h2.96V54.519a10.423,10.423,0,0,0-.257-2.387,4.59,4.59,0,0,0-.881-1.862",
    transform: "translate(-299.711 -43.979)",
    fill: "#2f3386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M486.966,61.795a5.863,5.863,0,0,1-.893.123c-.4.031-.779.049-1.138.049a2.348,2.348,0,0,1-2.093-.881,5.415,5.415,0,0,1-.6-2.937V51.44h-2.963v7.172A9.8,9.8,0,0,0,479.552,61a4.768,4.768,0,0,0,.893,1.874A4.137,4.137,0,0,0,482.11,64.1a6.633,6.633,0,0,0,2.581.442A18.193,18.193,0,0,0,487.7,64.3c.913-.154,1.657-.305,2.227-.453V51.44h-2.963Z",
    transform: "translate(-433.313 -46.506)",
    fill: "#2f3386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M621.827,53.752c-.245.824-.5,1.648-.773,2.472s-.547,1.625-.824,2.4-.542,1.474-.787,2.093c-.245-.619-.513-1.318-.8-2.093s-.565-1.574-.836-2.4-.525-1.648-.761-2.472-.448-1.594-.628-2.313h-3.16a73.668,73.668,0,0,0,2.347,7.012q1.292,3.268,2.521,5.789h2.532q1.228-2.52,2.518-5.789a72.886,72.886,0,0,0,2.347-7.012h-3.06q-.269,1.078-.639,2.313",
    transform: "translate(-554.442 -46.505)",
    fill: "#2f3386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M763.968,49.945a5.431,5.431,0,0,0-1.945-1.357,6.342,6.342,0,0,0-2.484-.479,6.246,6.246,0,0,0-2.473.479,5.594,5.594,0,0,0-1.948,1.357,6.234,6.234,0,0,0-1.272,2.119,7.946,7.946,0,0,0-.453,2.752,8.041,8.041,0,0,0,.453,2.766,6.271,6.271,0,0,0,1.26,2.13,5.637,5.637,0,0,0,1.933,1.372,6.218,6.218,0,0,0,2.5.49,6.324,6.324,0,0,0,2.51-.49,5.6,5.6,0,0,0,1.945-1.372,6.117,6.117,0,0,0,1.249-2.13,8.255,8.255,0,0,0,.439-2.766,7.947,7.947,0,0,0-.453-2.752,6.254,6.254,0,0,0-1.26-2.119m-2.142,7.931a2.888,2.888,0,0,1-4.577,0,5.086,5.086,0,0,1-.819-3.06,4.994,4.994,0,0,1,.819-3.023,2.911,2.911,0,0,1,4.577,0,5,5,0,0,1,.821,3.023,5.086,5.086,0,0,1-.821,3.06",
    transform: "translate(-681.136 -43.495)",
    fill: "#2f3386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M916.866,15.325a1.382,1.382,0,0,1-.6-.391,1.457,1.457,0,0,1-.3-.625,4.072,4.072,0,0,1-.086-.907V0a15.78,15.78,0,0,1-2.963.853V13.968a6.293,6.293,0,0,0,.208,1.7,2.737,2.737,0,0,0,.722,1.249,3.379,3.379,0,0,0,1.383.77,7.968,7.968,0,0,0,2.193.294h.791l-.378-2.447a4.767,4.767,0,0,1-.967-.208",
    transform: "translate(-825.355)",
    fill: "#2f3386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M989.882,51.109a3.822,3.822,0,0,0-.858-1.6,3.926,3.926,0,0,0-1.6-1.03,7.231,7.231,0,0,0-2.472-.368,12.812,12.812,0,0,0-2.3.2,12.114,12.114,0,0,0-1.64.391l.368,2.4a8.149,8.149,0,0,1,1.394-.342,11,11,0,0,1,1.885-.148,3.472,3.472,0,0,1,1.26.2,2.014,2.014,0,0,1,.81.55,2.07,2.07,0,0,1,.428.818,3.935,3.935,0,0,1,.123.981v.488a10.193,10.193,0,0,0-1.152-.208,9.317,9.317,0,0,0-1.027-.06,9.507,9.507,0,0,0-2.019.208,5.082,5.082,0,0,0-1.7.684,3.507,3.507,0,0,0-1.164,1.238,3.736,3.736,0,0,0-.428,1.859,4.4,4.4,0,0,0,.379,1.934,3.364,3.364,0,0,0,1.052,1.275,4.49,4.49,0,0,0,1.628.71,9.454,9.454,0,0,0,2.1.22,21.4,21.4,0,0,0,3.123-.208c.921-.14,1.611-.257,2.068-.356v-7.76a7.853,7.853,0,0,0-.257-2.068M987.276,59a10.84,10.84,0,0,1-2.082.148,3.4,3.4,0,0,1-1.788-.4,1.566,1.566,0,0,1-.659-1.457,1.527,1.527,0,0,1,.245-.893,1.647,1.647,0,0,1,.647-.55,3.033,3.033,0,0,1,.907-.268,6.492,6.492,0,0,1,.99-.074,6.34,6.34,0,0,1,1.029.074,5.978,5.978,0,0,1,.71.145Z",
    transform: "translate(-885.813 -43.495)",
    fill: "#2f3386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M157.227,78.16a.958.958,0,1,1-.729-1.142.958.958,0,0,1,.729,1.142",
    transform: "translate(-140.435 -69.61)",
    fill: "#2f3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M152.548,102.114a.779.779,0,1,1-.593-.928.779.779,0,0,1,.593.928",
    transform: "translate(-136.526 -91.465)",
    fill: "#2f3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M154.291,124.56a.679.679,0,1,1-.517-.81.68.68,0,0,1,.517.81",
    transform: "translate(-138.279 -111.867)",
    fill: "#2f3385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M163.179,143.583a.52.52,0,1,1-.4-.62.52.52,0,0,1,.4.62",
    transform: "translate(-146.598 -129.24)",
    fill: "#2f3385"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 27.518,
    height: 17.383,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8aa674e0445a77c7ba6b0a4b31902f7e.svg";
export { ForwardRef as ReactComponent };